import { ColumnEditor } from 'LookupEditor/ColumnEditors/Base/ColumnEditor';

export class BinaryColumnEditor extends ColumnEditor {
    Show(): void {}

    ToString() {
        return 'Binary';
    }
}
